<template>
  <!-- 登录模块 -->
  <div class="login-wrapper">

    <div class="login-box" @keydown="handleKeyDown">

    
      <!-- 头像 -->
      <div class="login-avatar">
        <!-- <img src="@/assets/logo.png" alt /> -->
        <img class="avt" src="../images/mengzhengfile.png" alt />
        <!-- <img src="@/assets/log2.png" alt /> -->
      </div>
      <!-- 登录表单 -->
      <el-form
        class="login-form"
        ref="loginFormRef"
        :model="adminLoginForm"
        :rules="adminLoginFormRules"
      >
        <h3 class="userlogin" style="color: #fff;">用户登录</h3>
        <!-- <div style="    display: flex;">
          <div class="flip-container">
            <div class="flipper">
              <div class="front">用</div>
              <div class="back">用</div>
            </div>
          </div>
          <div class="flip-container">
            <div class="flipper">
              <div class="front">户</div>
              <div class="back">户</div>
            </div>
          </div>
          <div class="flip-container">
            <div class="flipper">
              <div class="front">登</div>
              <div class="back">登</div>
            </div>
          </div>
          <div class="flip-container">
            <div class="flipper">
              <div class="front">录</div>
              <div class="back">录</div>
            </div>
          </div>
        </div> -->

        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input
            v-model="adminLoginForm.username"
            placeholder="请输入账号"
            @input="removeSpacesusername"
            maxlength="11"
            prefix-icon="iconfont iconicon"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            v-model="adminLoginForm.password"
            placeholder="请输入密码"
           @input="removeSpacespassword"
            prefix-icon="iconfont iconmima"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item class="button" style="width: 100%;">
          <div style="width: 100%; display: flex;">
            <el-button style="width: 50%;" type="primary" @click="login">登录</el-button>
            <el-button style="width: 50%;" type="success" @click="resetLoginForm">重置</el-button>
          </div>
        </el-form-item>
      </el-form>

      <div class="text-reveal" style="position: absolute; left: 12%;bottom: -90px;">
        <span >蒙</span>
        <span >正</span>
        <span >后</span>
        <span >台</span>
        <span >管</span>
        <span >理</span>
        <span >系</span>
        <span >统</span>
      </div>



    </div>


    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div id="stars4"></div>
    <div style="position: absolute;bottom: 30px;left: 45%;">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024079750号-2</a>
    </div>






  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from '../utils/loading';

import './style.css'

// import './utilsS/script.js'


// import  '../utils/denglong.js';

export default {
  name: "Admin",
  data() {
    return {

      text : "蒙正后台管理系统",
      container : null,
      directions : ['from-top', 'from-bottom', 'from-left', 'from-right'],
      index : 0,
      // 类型选择，默认选择管理员登录
      radio: "1",
      // 登录表单的对象
      adminLoginForm: {
        username: "",
        password: "",
      },
      adminLoginFormRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 3,
            max: 12,
            message: "长度在 5 到 12 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "密码长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  // computed: {
  //   filteredMenus() {
  //     return this.jur.filter(item => item.jurType === "menu");
  //   }
  // },
  mounted() {
    // this.container = document.getElementById('text-container');
    // this.handleinit()

    document.addEventListener('keydown', this.handleKeyDown);


    this.handleTime();
    this.handleAllrequest();


    let username = localStorage.getItem("username");
    let password = localStorage.getItem("password");
    if( username && password){
        this.adminLoginForm.username = username
        this.adminLoginForm.password = password
    }

  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

  },


  methods: {

    createChar(char, direction) {
      console.log(char, direction);
        const charElement = document.createElement('span');
        charElement.className = `text-char ${direction}`;
        charElement.textContent = char;
        this.container.appendChild(charElement);

        setTimeout(() => {
            charElement.style.opacity = 1;
            if (direction === 'from-top' || direction === 'from-bottom') {
                charElement.style.top = '50%';
            } else {
                charElement.style.left = '50%';
            }
        }, this.index * 200); // 每个字符之间的延迟时间（毫秒）
        this.index++;
    },
    handleinit(){
      this.text.split('').forEach((char, i) => {
          const direction = this.directions[i % this.directions.length];
          this.createChar(char, direction);
      });
    },
 

    removeSpacesusername(event){
      this.adminLoginForm.username = event.replace(/\s+/g, '');

    },

    removeSpacespassword(event){

      this.adminLoginForm.password = event.replace(/\s+/g, '');

    },

    //   // 重置方法
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },
    //   getType() {
    //     // 调用这个方法直接获取到了类型
    //   },

    handleKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        this.login()
      }
    },

    getRegionIds (token) {
      axios.get(`${apiBaseUrl}/deptOrTea/getRegionIds`,
        { headers:{'authorization': token}}).then(res => {
          let cityTepy = res.data.data;
          window.localStorage.setItem('cityTepy', cityTepy);

      }).catch(error => { })

    },

    login() {


      this.$refs.loginFormRef.validate((valid) => {
        // 表单预验证/deptOrTea/getRegionIds
        if (!valid) return;
        if (this.radio == 1) {
          loadingUtils.startLoading()
          // 登录
          this.$axios
            .post(`${apiBaseUrl}/admin/logintext`, {
              username: this.adminLoginForm.username,
              password: this.adminLoginForm.password,
            })
            .then((res) => {
              if (res.data.code == 200) {
                let ret = res.data.data;

                localStorage.setItem("username", this.adminLoginForm.username);
                localStorage.setItem("password", this.adminLoginForm.password);
                // 获取用户名和密码

                sessionStorage.setItem("isPriceType", ret.list.isPriceType ? ret.list.isPriceType : '');

                //把token保存到本地
                sessionStorage.setItem("tokenInfo", res.data.data.list.authorization);
                // this.$store.dispatch("getTokenInfo",res.data.data.list.authorization)
                window.localStorage.setItem("admin", JSON.stringify(ret.list));

                //
                window.localStorage.setItem("jur", JSON.stringify(ret.list.jur));

                this.getRegionIds(ret.list.authorization)

                if(ret.list.jur[0].children[0].jurUrl){
                  if(ret.list.jur[0].children[0].jurUrl === '/customercollect' || ret.list.jur[0].children[0].jurUrl === '/customermange' ){
                     this.$router.push('/customermange');
                  }else{
                     this.$router.push(ret.list.jur[0].children[0].jurUrl);

                  }
                }else{
                   this.$router.push(ret.list.jur[0].children[0].jurUrl);
                }

                let token = ret.token;
                //调用vuex的commit方法，将token保存到vuex中，来触发一个名为 "LOGIN_IN" 的 mutation
                this.$store.commit("LOGIN_IN", token);
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
                });
              } else {
                // alert(res.data.message);
                this.$message.error(res.data.message);
                this.adminLoginForm.password = "";
              }
            })
            .catch((error) => {
              this.$message.error("登录失败");
            })
            .finally(() => {
              setTimeout(() => {
                loadingUtils.endLoading()
              },500)
            });
        }
      });
    },
    formatConvert(date) {
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    handleTime() {
      const now = new Date(); // 获取当前日期
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // 获取当前月的第一天
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天

      // this.startTime1 = this.formatConvert(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() - 7))
      // this.endTime1 = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 11))
      this.startTime1 = this.formatConvert(
        new Date(
          firstDay.getFullYear(),
          firstDay.getMonth(),
          firstDay.getDate()
        )
      );
      this.endTime1 = this.formatConvert(
        new Date(
          lastDay.getFullYear(),
          lastDay.getMonth(),
          lastDay.getDate()
        )
      );
      sessionStorage.setItem("TIME_START", this.startTime1)
      sessionStorage.setItem("TIME_END", this.endTime1)
    },
    handleAllrequest() {
      axios.get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("teacherlist_Jons", JSON.stringify(data.data));
        }
      });
      axios.get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("categorylist_Jons", JSON.stringify(data.data));
        }
      });

      axios
        .post(`${apiBaseUrl}/schedule/selectschedule`, {
          teacher_id: "",
          page: "",
          limit: "",
          start_time: this.startTime1,
          end_time: this.endTime1,
          student_id: "",
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            sessionStorage.setItem("selectschedule_Jons", JSON.stringify(data.data));
          }
        });
      //  规划学生 studentType：1
      axios.post(`${apiBaseUrl}/student/getStudentList`,{
        studentType:1
      },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("getStudentList_Jons", JSON.stringify(data.data));
        }
      });
      // 线下学生 studentType：2
      axios.post(`${apiBaseUrl}/student/getStudentList`,{
        studentType:2
      },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("getStudentList_Jons_s", JSON.stringify(data.data));
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 50px;
}

.login-type {
  display: flex;
  justify-content: left;
}

.button {
  display: flex;
  margin-top: 15px;
  width: 100%;

  // justify-content: center;
}

/deep/ .el-form-item__content {
  display: flex;
  width: 100%;
}

.login-wrapper {
  // background:  #428BCA;
  background: #1d3a4b;
  height: 100%;
}
.login-avatar {
  height: 150px;
  width: 150px;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 49%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    height: 100%;
    width: 100%;
    border-radius: 10px;
  }
}

.title {
  color: #fff;
}

.userlogin {
  text-align: center;
  margin-right: 8px;
}

.login-box {
  width: 550px;
  height: 380px;
  // background-color: #fff;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 750px) {
  .login-avatar {
    width: 90px;
    height: 90px;
  }
  .login-box {
    width: 380px;
    height: 350px;
  }
}

@keyframes rotateCircle {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.avt {
  // animation: rotateCircle 5s linear infinite;
}









.flip-container {
  perspective: 800px; /* 设置透视距离 */
}

.flipper {
  position: relative;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  font-size: 40px;
  font-weight: bold;
  color: white;
  transform-style: preserve-3d;
  animation: flip 2s infinite;
}

.front, .back {
  position: absolute;
  width: 100px;
  height: 100px;
  // background: #3498db;
  border-radius: 10px;
  backface-visibility: hidden; /* 隐藏背面 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.back {
  transform: rotateY(180deg);
}

/* 翻转动画 */
@keyframes flip {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

.text-reveal {
  display: flex;
  font-size: 48px;
  color: #fff;
  font-family: sans-serif;
  gap: 4px;
}

.text-reveal span {
  opacity: 0;
    animation: fadeIn 0.5s ease forwards;
}

/* 每个字符依次出现 */
.text-reveal span:nth-child(1) { animation-delay: 0.1s; }
.text-reveal span:nth-child(2) { animation-delay: 0.3s; }
.text-reveal span:nth-child(3) { animation-delay: 0.6s; }
.text-reveal span:nth-child(4) { animation-delay: 0.9s; }
.text-reveal span:nth-child(5) { animation-delay: 1.2s; }
.text-reveal span:nth-child(6) { animation-delay: 1.5s; }
.text-reveal span:nth-child(7) { animation-delay: 1.8s; }
.text-reveal span:nth-child(8) { animation-delay: 2.1s; }

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}




.fire-text {
  font-size: 80px;
  font-family: 'Arial Black', sans-serif;
  color: #ff6600;
  position: relative;
  text-shadow:
    0 0 5px #ff6600,
    0 0 10px #ff9900,
    0 0 20px #ff9900,
    0 0 30px #ff9900,
    0 0 40px #ffcc00;
  animation: flicker 2s infinite;
}

/* 伪元素模拟火焰外层 */
.fire-text::before {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #ff9900;
  filter: blur(2px);
  opacity: 0.8;
  animation: flame 2s infinite ease-in-out;
  z-index: -1;
}

/* 火焰抖动动画 */
@keyframes flicker {
  0%, 100% { transform: scaleY(1) scaleX(1); }
  25% { transform: scaleY(1.05) scaleX(0.98); }
  50% { transform: scaleY(0.95) scaleX(1.02); }
  75% { transform: scaleY(1.02) scaleX(0.98); }
}

/* 火焰闪烁动画 */
@keyframes flame {
  0%, 100% { transform: skewX(0deg) skewY(0deg); }
  25% { transform: skewX(2deg) skewY(-1deg); }
  50% { transform: skewX(-3deg) skewY(2deg); }
  75% { transform: skewX(1deg) skewY(-1deg); }
}


/* styles.css */
#text-container {
    position: relative;
    height: 100vh; /* 使容器高度占满整个视窗 */
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.text-char {
    position: absolute;
    font-size: 60px;
    color: #ff9900;
    opacity: 0;
    transition: all 1s ease-in-out;
}

.from-top {
    top: -100px;
}

.from-bottom {
    bottom: -100px;
}

.from-left {
    left: -100px;
}

.from-right {
    right: -100px;
}

</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue